module.exports = __webpack_public_path__ + "img/pp-46.bcb77eed.jpg";